import React, { FC, useState, useEffect } from 'react'
import { keyBy } from '@dt/fe-utils/dist/lodash'
import { modalLayer, getCouponsInfo, toast } from '@utils'
import { memberMobx } from '@mobxStore'
import { format } from '@dt/fe-utils'
import ActivityApi from '@api/activity.api'
import McGiveDetail from '../McGiveDetail'
import i18n from 'i18next'
import './index.scss'

import recommendImg from '@img/mkt/recommend.png'

interface IProps {
  value?: any;
  data: any[];
  onChange: (val: any) => void;
}

const McRechargeStall: FC<IProps> = ({ value, data, onChange }: IProps) => {
  const [couponMap, setCouponMap] = useState<any>({})
  const { brandConfig } = memberMobx

  const handleShowGive = (item: any, cnt: number) => {
    modalLayer(McGiveDetail, { info: item, couponMap, cnt }, 'giveDetail')
  }

  const handleChange = (item: any) => {
    if (brandConfig.memberCardCzSetting && !brandConfig.memberCardCzSetting.channels.includes('mobile')) {
      toast({ message: i18n.t('mkt.member.notRechargeTip') })
      return
    }
    onChange && onChange(value?.cardRechargeId === item.cardRechargeId ? null : item)
  }

  useEffect(() => {
    if (data.length > 0) {
      let list: any = []
      data.map((item: any) => {
        if (item.coupons.length > 0) list = list.concat(item.coupons)
      })
      if (list.length > 0) {
        ActivityApi.getCouponsList({
          couponIds: getCouponsInfo(list)
        }).then((res: any) => {
          if (!res.error) {
            setCouponMap(keyBy(res, 'couponId'))
          }
        })
      }
    }
  }, [data])

  return (
    <div className='mc-recharge-stall'>
      {
        data.map((item: any, index: number) => {
          const cnt = getCouponsInfo(item.coupons, 'cnt', couponMap)
          return (
            <div className='stall-amount-item' key={index} data-cypid={`mcRechargeStall_${index}`} onClick={() => handleChange(item)}>
              {
                item?.ifRecommend &&
                  <div
                    className='recommend'
                    style={{ backgroundImage: `Url(${recommendImg})` }}
                  >
                  </div>
              }
              <i className={`iconfont ${value?.cardRechargeId === item.cardRechargeId ? 'icon-checked' : 'icon-circle'}`}></i>
              <div className='amount-block'>
                <div className='amount'>{format.toPrice(item.money, 2)}</div>
                {
                  item.moneyGive > 0 || cnt > 0 ? (
                    <div
                      className='give-area'
                      data-cypid={`mcRechargeStallGive_${index}`}
                      onClick={(e: any) => {
                        e.stopPropagation()
                        handleShowGive(item, cnt)
                      }}
                    >
                      {item.moneyGive > 0 && <span>{i18n.t('mkt.giftCard.giveAway')} {format.toPrice(item.moneyGive, -1)}</span>}{item.moneyGive > 0 && cnt > 0 && ';'}{cnt > 0 && <span>{i18n.t('mkt.coupon.freeCouponNumber', { number: cnt })}</span>}
                    </div>
                  ) : ''
                }
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default McRechargeStall
